import * as React from 'react';
import { createSyncObservable } from '@avensia/excite';
import { styled } from '@glitz/react';
import { srOnlyDecorator } from './sharedTheme';

type PropType = {
  message: string;
  mode?: 'polite' | 'assertive';
};

export const [ariaLiveObservable] = createSyncObservable<PropType>({ message: '', mode: 'polite' });

const AriaLiveRegion = () => {
  const [ariaLiveState, setAriaLiveState] = React.useState<PropType>({ message: '', mode: 'polite' });
  const [isClient, setIsClient] = React.useState(false);

  React.useEffect(() => {
    const subscription = ariaLiveObservable.on(v => {
      setAriaLiveState({ message: v.message, mode: v.mode ?? 'polite' });
    });

    return subscription;
  }, []);

  React.useEffect(() => {
    if (!isClient) setIsClient(true);
  }, [isClient]);

  if (!isClient) return null;

  return (
    <HiddenDiv
      suppressHydrationWarning
      aria-atomic
      aria-live={ariaLiveState.mode ?? 'polite'}
      style={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        margin: '-1px',
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        whiteSpace: 'nowrap',
      }}
    >
      {ariaLiveState.message}
    </HiddenDiv>
  );
};

const HiddenDiv = styled.div(srOnlyDecorator);

export default AriaLiveRegion;
